import DashboardLayout from './Dashboard';

export default DashboardLayout;
